module.exports = __webpack_public_path__ + "362052b1e1c1bf7048a52f0861370ddf.png";